import { render, staticRenderFns } from "./cohorts.vue?vue&type=template&id=0b875e06"
import script from "./cohorts.vue?vue&type=script&lang=js"
export * from "./cohorts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports